import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement, userManagementBaseUrl } from '../endpoints';

export const memberInterviewRecordService = createApi({
    reducerPath: "memberInterviewRecordService",
    baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
    tagTypes: ["MemberInterviewRecord"],

    endpoints: (builder) => ({

        // ⭐ GET ALL PAGINATED WITH SORTING
        getAllMemberInterviewRecord: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.memberInterviewRecordController.getAllMemberInterviewRecord}/${body.page}/${body.size}?orderBy=${body.sort}`,
                    method: "GET",
                    headers: { Authorization: `Bearer ${body.token}` },
                };
            },
        }),

        // ⭐ GET BY ID
        getMemberInterviewRecordById: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.memberInterviewRecordController.getMemberInterviewRecordById}/${body.id}`,
                    method: "GET",
                    headers: { Authorization: `Bearer ${body.token}` },
                };
            },
        }),

        // ⭐ SAVE
        saveMemberInterviewRecord: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.memberInterviewRecordController.saveMemberInterviewRecord}`,
                    method: "POST",
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload, // JSON or multipart/form-data
                };
            },
        }),

        // ⭐ UPDATE
        updateMemberInterviewRecord: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.memberInterviewRecordController.updateMemberInterviewRecord}/${body.id}`,
                    method: "PUT",
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                };
            },
        }),

        // ⭐ DELETE
        deleteMemberInterviewRecord: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.memberInterviewRecordController.deleteMemberInterviewRecord}/${body.id}`,
                    method: "DELETE",
                    headers: { Authorization: `Bearer ${body.token}` },
                };
            },
        }),

        // ⭐ SEARCH
        getAllMemberInterviewRecordBySearch: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.memberInterviewRecordController.getAllMemberInterviewRecordBySearch}`,
                    method: "POST",
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                };
            },
        }),

        // ⭐ FIND ALL (NO PAGINATION)
        findAllMemberInterviewRecord: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.memberInterviewRecordController.findAllMemberInterviewRecord}`,
                    method: "GET",
                    headers: { Authorization: `Bearer ${body.token}` },
                };
            },
        }),

        // ⭐ BULK UPLOAD
        bulkSaveMemberInterviewRecord: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.memberInterviewRecordController.bulkSaveMemberInterviewRecord}`,
                    method: "POST",
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload, // multipart form-data
                };
            },
        }),

    }),
});

export const {
    useGetAllMemberInterviewRecordMutation,
    useGetMemberInterviewRecordByIdMutation,
    useSaveMemberInterviewRecordMutation,
    useUpdateMemberInterviewRecordMutation,
    useDeleteMemberInterviewRecordMutation,
    useGetAllMemberInterviewRecordBySearchMutation,
    useFindAllMemberInterviewRecordMutation,
    useBulkSaveMemberInterviewRecordMutation,
} = memberInterviewRecordService;
